export const EDUNODES_HOME_URL = 'https://edunodes.tech'

export const EDUNODES_PLATFORM_DOMAIN = 'edunodes.tech'

/** Default site logo for Edunodes-powered tenant communities. */
export const EDUNODES_COMMUNITY_LOGO_URL = '/svg/edunodes.svg'

/** Favicon-optimized crop of the Edunodes logo (tighter viewBox for browser tab icons). */
export const EDUNODES_COMMUNITY_FAVICON_URL = '/svg/edunodes-favicon.svg'

export type EdunodesCommunitySummary = {
  subdomain: string
  name: string
  customDomain?: string | null
}

/** Public site hostname: active custom domain or {subdomain}.edunodes.tech */
export function getEdunodesCommunitySiteHost(
  community: Pick<EdunodesCommunitySummary, 'subdomain' | 'customDomain'>
): string {
  const custom = community.customDomain?.trim()
  if (custom) {
    return custom
  }
  const sub = community.subdomain?.trim()
  return sub ? `${sub}.${EDUNODES_PLATFORM_DOMAIN}` : EDUNODES_PLATFORM_DOMAIN
}

export function getEdunodesCommunitySiteUrl(
  community: Pick<EdunodesCommunitySummary, 'subdomain' | 'customDomain'>
): string {
  return `https://${getEdunodesCommunitySiteHost(community)}`
}
